export default __webpack_public_path__ + "static/media/github.782f8e84.svg";